import appAuthApiClient from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getLineItemPropertiesFromProductBatchRpc } from '../../__generated__/chirp/com/hubspot/lineitems/rpc/LineItemCreateUtilityRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: appAuthApiClient
});
export const getLineItemPropertiesFromProductBatch = ({
  requests,
  currencyCode
}) => chirpClient.call(getLineItemPropertiesFromProductBatchRpc, {
  request: {
    requests,
    currencyCode
  }
});